import { motion } from "framer-motion";
import { commonOpacity } from "../../../animateConstant";
import { getFixedStyle } from "../../../hook/useDeviceType";
import { HiChevronLeft } from "react-icons/hi";
import { useNavigate, useParams } from "react-router";
import CloseComponent from "../../../components/CloseComponent/CloseComponent";
import { VipList } from "../vipList";
import { TbPokerChip } from "react-icons/tb";
import { IoLogoGameControllerA } from "react-icons/io";
import PromotionCard from "./promotionCard";
import DetailWrapper from "../../../components/detailWrapper";
import { LazyLoadImage } from "react-lazy-load-image-component";
import LoadingImage from "../../../components/Loading/LoadingImage";
import { useState } from "react";
import LazyImage from "../../../components/Loading/lazyImage";
import CloseDetailPage from "../../../components/CloseComponent/CloseDetailPage";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { vipPromotion } from "../helper/detailList";
import VipPromotionList from "./vipPromotionList";

const VipDetail = () => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`vip.${key}`, { ...props });

  const navigate = useNavigate();

  const memberData = useSelector((state) => state.isMemberInfo);
  const vipList = useSelector((state) => state.isVipDetail);

  const { vipInfo } = memberData;

  const { vipId } = useParams();

  return (
    <DetailWrapper
      closeAnimate
      wrapperClassName={`h-full w-full md:absolute fixed top-0 left-0 max-h-full z-[1] bg-gradient-to-br ${VipList[vipId]?.background}`}
    >
      <article className={`w-full h-full`}>
        <CloseDetailPage
          hasPrev={
            <HiChevronLeft
              className="cursor-pointer"
              onClick={() => navigate("../")}
            />
          }
          title={i18n("title")}
        />
        <section className="flex flex-col gap-[10px] items-center">
          <div>
            <LazyImage
              className="!w-[180px] !h-[180px] object-scale-down"
              src={vipList[vipId]?.icon}
              loadingClassName={`rounded-full`}
            />
          </div>
          <div className="flex flex-col items-center gap-[10px]">
            {/* <span className="text-light-white text-2xl font-medium">
              {i18n(vipList[vipId]?.label.toLowerCase())}
            </span> */}
            <div
              className={`rounded-full py-[5px] px-[10px] text-sm text-base-white tracking-tighter ${
                vipInfo?.vip_lv_now >= vipId ? "bg-green-500" : "bg-yellow-500"
              } flex justify-center`}
            >
              {vipInfo?.vip_lv_now >= vipId
                ? i18n("completed")
                : i18n("inProgress")}
            </div>
          </div>
          <div className="w-[80%] mx-auto flex flex-col gap-[3px]">
            <VipPromotionList customLevel={vipId} />
          </div>
        </section>
      </article>
    </DetailWrapper>
  );
};

export default VipDetail;
